import { render, staticRenderFns } from "./EIDList.vue?vue&type=template&id=128545ac&scoped=true&"
import script from "./EIDList.vue?vue&type=script&lang=js&"
export * from "./EIDList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128545ac",
  null
  
)

export default component.exports